<template>
  <b-modal
    id="share-reward-modal"
    title="Share Reward Link"
    centered
    no-close-on-backdrop
    hide-footer
  >
    <b-input-group>
      <b-input
        :value="rewardLink"
        readonly
        class="bg-white"
        id="reward-link-input"
      />
      <b-input-group-text slot="append">
        <img src="@/assets/images/actions/copy-gray.svg" alt="Copy" @click="copyLink" />
      </b-input-group-text>
    </b-input-group>
  </b-modal>
</template>

<script>
import notification from "@/services/notification";

export default {
  name: "ShareRewardModal",
  data() {
    return {
      rewardLink: "https://www.rush.com.ph/",
    };
  },
  methods: {
    copyLink() {
      document.getElementById("reward-link-input").select();
      document.execCommand("copy");
      notification.success("Link Copied!");
    },
  },
};
</script>

<style scoped>
.modal-title {
  margin-left: 30px;
  font-family: MainFontBold, sans-serif;
  font-weight: normal;
}
.modal-title ::after {
  width: 0;
  height: 0;
}
#reward-link-input {
  background: #eef4ff !important;
  color: #5182FF;
  font-family: MainFontBold, sans-serif;
  font-weight: normal;
  border: 0;
}
.input-group-text {
  border: 0;
  background: #FFFFFF;
  cursor: pointer;
}
</style>